import styles from "./PlaceholderControl.module.scss";

const PlaceholderControl: React.FC<{ text: string }> = (props: {
  text: string;
}) => {
  return <span className={styles.placeholderControl}>{props.text}</span>;
};

export default PlaceholderControl;
